/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["dje",[["Subbaahi","Zaarikay b"],u,u],u,[["H","T","T","L","M","Z","S"],["Alh","Ati","Ata","Ala","Alm","Alz","Asi"],["Alhadi","Atinni","Atalaata","Alarba","Alhamisi","Alzuma","Asibti"],["Alh","Ati","Ata","Ala","Alm","Alz","Asi"]],u,[["Ž","F","M","A","M","Ž","Ž","U","S","O","N","D"],["Žan","Fee","Mar","Awi","Me","Žuw","Žuy","Ut","Sek","Okt","Noo","Dee"],["Žanwiye","Feewiriye","Marsi","Awiril","Me","Žuweŋ","Žuyye","Ut","Sektanbur","Oktoobur","Noowanbur","Deesanbur"]],u,[["IJ","IZ"],u,["Isaa jine","Isaa zamanoo"]],1,[6,0],["d/M/y","d MMM, y","d MMMM y","EEEE d MMMM y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],["."," ",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","#,##0.00¤","#E0"],"XOF","F CFA","CFA Fraŋ (BCEAO)",{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
